import React from 'react';

import { Chip, Tooltip } from '@mui/material';

import { RateTypeLabel, getRateTypeLabel } from '~/components/Accommodation/utils/rates';

import { Rate } from '~/services/AccommodationService';

interface RateTypeBadgeProps {
  rate: Rate;
}

const RATE_TYPE_CHIPS: Record<RateTypeLabel, { title: string; color: 'primary' | 'secondary' | 'warning' }> = {
  LPC: { title: 'Luxury Property Collection', color: 'primary' },
  Bedbank: { title: 'Luxury Property Partner', color: 'secondary' },
  Flash: { title: 'Flash offer, sold at its static package price', color: 'warning' },
};

export default function RateTypeBadge({ rate }: RateTypeBadgeProps) {
  if (!rate.meta) {
    return null;
  }

  const label = getRateTypeLabel(rate);
  const { title, color } = RATE_TYPE_CHIPS[label];

  return (
    <Tooltip title={title}>
      <Chip label={label} color={color} size="small" sx={{ mr: 1 }} />
    </Tooltip>
  );
}
